export { default as GrowlMessages } from 'messages/containers/GrowlMessagesContainer';
export { default as InlineMessages } from 'messages/containers/InlineMessagesContainer';



// WEBPACK FOOTER //
// src/modules/messages/containers/index.js